export const GAO_DE_GEO_URL = "https://restapi.amap.com/v3/geocode/geo";
// export const SERVER_URL = 'http://localhost:8080';
export const GAO_DE_KEY = "0474a745d094cec483b7f9f988ba8216";
export const GAO_DE_ADDRESS = "c72ccd557512d20dbaff7b16a280fd33";
